import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useI18n } from '~/hooks/use-i18n';

import { updateCatalogUrlState } from '../utils/catalog-url-state-utils';

export function useCatalogFilterLanguageQueryParam() {
  const router = useRouter();
  const { i18n, isJa } = useI18n();

  useEffect(() => {
    // Clear language filter
    function removeLanguageQueryParam() {
      updateCatalogUrlState({
        router,
        updatedRouteParameters: {
          language: undefined,
        },
      });
    }

    // Remove language query param if current language is not Japanese and param exists
    if (!isJa && router.query.language) {
      removeLanguageQueryParam();
    }

    // When current language is Japanese, listen for changes to non-Japanese languages
    if (isJa) {
      function handleLanguageChange(incomingLanguage: string) {
        if (incomingLanguage !== 'ja') {
          removeLanguageQueryParam();
        }
      }

      i18n.on('languageChanged', handleLanguageChange);
      return () => {
        i18n.off('languageChanged', handleLanguageChange);
      };
    }
  }, [isJa, router, i18n]);
}
